import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5d86b74&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=c5d86b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d86b74",
  null
  
)

export default component.exports